module.exports = __webpack_public_path__ + "static/media/freshgrocer-icon-tier-complete-no-shadow.3586bd9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/freshgrocer-icon-tier-complete-no-shadow.svg
// module id = 369
// module chunks = 0